import { AxiosError } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getResponseError } from '@utils/error';
import { SagaPayload } from '@utils/typescript';
import { UserMobileNumberApi } from '@apis/UserMobileNumberApi';
import { currentUserFetch } from '@components/Auth';
import {
  mobileNumberUpdate,
  UpdateMobileNumberPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleMobileNumberUpdate({ payload }: SagaPayload<UpdateMobileNumberPayload>) {
  try {
    yield call(UserMobileNumberApi.update, payload);
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
    yield put(currentUserFetch())
  } catch (e) {
    const { errors } = getResponseError(e as AxiosError);
    const state: StateUpdatePayload = { isSuccess: false, serverErrors: errors };
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(mobileNumberUpdate, handleMobileNumberUpdate);
}
